var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCutCircleYellow = function SvgCutCircleYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FDB022",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M4.667 13.775A6.66 6.66 0 0 0 8 8a6.66 6.66 0 0 0-3.333-5.775m10 5.775A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.334 0"
  })));
};
export default SvgCutCircleYellow;